__turbopack_context__.v({
  "accountButton": "vEMo6G_accountButton",
  "backButtonSlot": "vEMo6G_backButtonSlot",
  "content": "vEMo6G_content",
  "contentWithLoginMenu": "vEMo6G_contentWithLoginMenu",
});
